export const IS_USER_LOGGED_IN = 'IS_USER_LOGGED_IN'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const APP_DRAWER_STATE = 'APP_DRAWER_STATE'
export const GET_KEY_LIST = 'GET_KEY_LIST'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const IS_DATA_CHANGED = 'IS_DATA_CHANGED'
export const IS_INVALID_TOKEN = 'IS_INVALID_TOKEN'

//DAILY MENU
export const TEMPLATE_MENU_OFFER = 'TEMPLATE_MENU_OFFER'
export const DAILY_MENU_CHANGE_SET = 'DAILY_MENU_CHANGE_SET'
export const SELECTED_DAILYMENU_VIEW = 'SELECTED_DAILYMENU_VIEW'
export const DAILY_MENU_OFFER_TEMPLATE = 'DAILY_MENU_OFFER_TEMPLATE'
export const LOADING_DAILYMENU = 'LOADING_DAILYMENU'
export const SEARCHED_FOOD = 'SEARCHED_FOOD'
export const DAILY_MENU_OFFER = 'DAILY_MENU_OFFER'
export const MENU_OFFER = 'MENU_OFFER'
export const DAILY_MENU_TOP_GROUP_OFFER = 'DAILY_MENU_TOP_GROUP_OFFER'
export const SELECTED_VIEW = 'SELECTED_VIEW'
export const CURRENT_USER_RESERVATION_RANGE_DATA = 'CURRENT_USER_RESERVATION_RANGE_DATA'
export const USER_SETTINGS_4_ORDERING = 'USER_SETTINGS_4_ORDERING'

export const DAILY_MENU_TOP_GROUP_CHANGE_SET = 'DAILY_MENU_TOP_GROUP_CHANGE_SET'
export const DAILY_MENU_TOP_GROUP_SAVED = 'DAILY_MENU_TOP_GROUP_SAVED'

//RESERVATION PAGE
export const LOADING_RESERVATION = 'LOADING_RESERVATION'
export const CURRENT_RESERVATION = 'CURRENT_RESERVATION'
export const CURRENT_RESERVATION_HEADER = 'CURRENT_RESERVATION_HEADER'

export const GET_CALENDAR_EVENTS = 'GET_EVENTS'
export const GET_LOADING_WEEKCALENDAR = 'GET_LOADING_WEEKCALENDAR'

export const GET_CONFIG = 'GET_CONFIG'
export const SUPPORTED_LANGUAGES = 'SUPPORTED_LANGUAGES'
export const CURRENT_UI_LANGUAGE = 'CURRENT_UI_LANGUAGE'
export const SHOW_ERROR_RESPONSE_DIALOG = 'SHOW_ERROR_RESPONSE_DIALOG'
export const ERROR_RESPONSE_DIALOG_DATA = 'ERROR_RESPONSE_DIALOG_DATA'

export const GET_SMART_LINK_FILTER = 'GET_SMART_LINK_FILTER'

